import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, BadgeCheck, Phone } from "lucide-react";
const ConsumerHero = () => {
  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-20 px-4 bg-cover bg-center" style={{
    backgroundImage: "url('/images/consumer-hero-aerial.png?v=2')"
  }}>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-[#080c14]/60 -z-10" />
      
      <div className="container mx-auto text-center max-w-4xl relative z-10">
        <div className="inline-flex items-center gap-2 bg-[#ffd700]/10 border border-[#ffd700]/20 rounded-full px-4 py-2 mb-6">
          <BadgeCheck className="h-5 w-5 text-[#ffd700]" />
          <span className="text-[#ffd700] font-semibold">100% Free Service</span>
        </div>
        
        <h1 className="text-5xl sm:text-6xl font-bold mb-6 leading-tight">
          Sell Your Home Faster with{" "}
          <span className="text-[#ffd700]">Free Professional Marketing</span>
        </h1>
        
        <p className="text-xl mb-8 max-w-3xl mx-auto text-slate-200">
          Get your property in front of serious cash buyers and investors - at no cost to you
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link to="/consumer/get-started">
            <Button size="lg" className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] px-8 hover-lift group w-full sm:w-auto">
              Get Started
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <Button size="lg" variant="outline" onClick={scrollToHowItWorks} className="border-gray-600 text-white hover:bg-gray-800 w-full sm:w-auto">
            See How It Works
          </Button>
        </div>
        
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
          <div className="flex items-center gap-2">
            <BadgeCheck className="h-4 w-4 text-[#ffd700]" />
            <span className="text-slate-50">No fees</span>
          </div>
          <div className="flex items-center gap-2">
            <BadgeCheck className="h-4 w-4 text-[#ffd700]" />
            <span className="text-slate-50">No obligations</span>
          </div>
          <div className="flex items-center gap-2">
            <BadgeCheck className="h-4 w-4 text-[#ffd700]" />
            <span className="text-slate-50">Professional service</span>
          </div>
        </div>
        
        <a 
          href="tel:2489977335" 
          className="inline-flex items-center gap-2 mt-6 text-lg font-semibold text-[#ffd700] hover:text-[#e6c200] transition-colors"
        >
          <Phone className="h-5 w-5" />
          (248) 997-7335
        </a>
      </div>
    </section>;
};
export default ConsumerHero;